
import get from 'lodash/get';

import { getModules } from '../../core';

export default function getAppModules(projectDefinition) {
    let appModules = getModules().map(item => item.getId());
    let projectModules = get(projectDefinition, 'app.modules', {});

    const modulesRequiredProjectDef = [
        'search'
    ];

    let modules = appModules.filter(item => {
        return (modulesRequiredProjectDef.indexOf(item) !== -1)
            ? (!!projectModules[item])
            : true;
    });

    return modules;
}
